export default __webpack_public_path__ + "static/media/business-advisory-3.d0400c33.svg";